import React from "react";
import { PageIntro } from "../components/PageIntro";
import { ClosingCTA } from "../components/ClosingCTA";
import { processGroups } from "../data/services";
import { photos } from "../data/photography";
export function ProcessControls() {
  return <>
      <PageIntro label="Process & Controls" title="The processes that keep payroll and HR technology working." statement="Good systems still fail without good habits around them." image={photos.optimizeFiles} imageCaption="Written down, put away, and easy to find." data-id="element-848" data-mp="1aqypmg2kizld">
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-charcoal/80" data-id="element-849" data-mp="s2bi7qwx5y4m">
          We write down how the work actually gets done, set the schedule, put the right checks in place, and take out
          the manual steps — for payroll and for the HR systems that feed it.
        </p>
      </PageIntro>

      <section aria-label="Process and controls work" className="shell pb-24 md:pb-32" data-id="element-850" data-mp="4chafnrgizr8">
        <ol className="border-t border-navy" data-id="element-851" data-mp="qslen3f5vq0b">
          {processGroups.map((g, i) => <li key={g.name} className="grid grid-cols-12 gap-x-6 gap-y-6 border-b border-stone py-12 md:py-14" data-id="element-852" data-mp="qufqls8gg7s9" data-mpi={i}>
              <span className="col-span-12 font-display text-lg tabular-nums text-oxblood md:col-span-1" data-id="element-853" data-mp="h2idgfxvz5qw">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="col-span-12 md:col-span-5" data-id="element-854" data-mp="c1m8s05pnfkf">
                <h2 className="font-display text-[clamp(2rem,3.4vw,3rem)] leading-[1.05] text-navy" data-id="element-855" data-mp="8355jrpeup8a">{g.name}</h2>
                <p className="mt-4 font-display text-xl italic text-oxblood" data-id="element-856" data-mp="31fqm0z2hrex">{g.line}</p>
              </div>
              <ul className="col-span-12 self-start border-b border-stone md:col-span-5 md:col-start-8" data-id="element-857" data-mp="3u9k5pxh0seoa">
                {g.items.map(item => <li key={item} className="border-t border-stone py-3 text-[15px] text-charcoal" data-id="element-858" data-mp="1sigtx4ve8u25">
                    {item}
                  </li>)}
              </ul>
            </li>)}
        </ol>
      </section>

      <ClosingCTA data-id="element-859" data-mp="3hxhrzhgyj9no" />
    </>;
}